export default "dist/images/components-columns-width-control-2-1-grid.78b21b6.png";